import Decimal from 'decimal.js'

import { roundFloat } from '@/utils/number.utils'

type Periodo = 'Anual' | 'Semestral' | 'Mensal'

export class CalculadoraJuros {
  constructor(private readonly percentualJurosAnualPrice: number) {}

  static readonly CASAS_DECIMAIS_JUROS = 8

  public conversaoTaxaAnualPara(periodo: Periodo): number {
    const PORCENTAGEM = 100

    const taxaMensal = roundFloat(
      new Decimal(this.percentualJurosAnualPrice)
        .dividedBy(PORCENTAGEM)
        .plus(1)
        .toPower(new Decimal(1).dividedBy(12))
        .minus(1)
        .toNumber(),
      CalculadoraJuros.CASAS_DECIMAIS_JUROS,
    )
    if (periodo === 'Mensal') return taxaMensal

    const valorPeriodoParaTaxa = { Anual: 12, Semestral: 6 }

    const taxaMega = new Decimal(taxaMensal).plus(1).toPower(valorPeriodoParaTaxa[periodo]).minus(1)
    return roundFloat(taxaMega.toNumber(), CalculadoraJuros.CASAS_DECIMAIS_JUROS)
  }

  /**
   * @param n - Período a ser cálculado (mensal/anual/diaria/semestral)
   * @param i - Taxa de juros (a.m/a.a/a.d/a.s)
   * @param pv - Valor inicial a ser cálculado
   */
  public calcularPrestacao(n: number, i: number, pv: number): number {
    return pv / (((1 + i) ** n - 1) / ((1 + i) ** (n - 1) * i))
  }

  /**
   * @param n - Período a ser calculado (mensal/anual/diaria/semestral)
   * @param i - Taxa de juros (a.m/a.a/a.d/a.s)
   * @param pv - Valor presente (capital inicial)
   */
  public calcularValorFuturo(n: number, i: number, pv: number): number {
    return pv * (1 + i) ** n
  }
}
